import Box from "@mui/material/Box";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import { styled, TablePagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImportFileContext } from "../../contexts/ImportFileContext";

import { common, input } from "../../i18n";
import { ImportActivitiesHistoryForDataTable } from "./ImportFilePopup.type";
import { ImportDetailsTable } from "./_components/ImportDetailsTable";
import { ChangeEvent, useEffect, useRef, useState } from "react";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--dark)",
    color: "white",
    textAlign: "left",
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

interface Props {
  search: string;
  status: string;
}

export const ImportFileHistoryTable = (props: Props) => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });

  const { rows } = ImportFileContext();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [filterRows, setFilterRows] = useState([...rows]);

  useEffect(() => {
    setPage(0);

    let result: ImportActivitiesHistoryForDataTable[] = [...rows];
    if (props.status !== "all") {
      result = rows.filter((f) => {
        return f.status === props.status;
      });
    }

    result = result.filter((f) => {
      let allValuesForSearch: string[] = [];

      allValuesForSearch = [
        f.id.toString(),
        f.filename,
        f.importedBy,
        // f.importedBy.email,
      ];

      let result = allValuesForSearch.filter((e) =>
        e?.includes(props.search.trim().toLowerCase()),
      );

      if (result.length > 0 || props.search.trim() === "") {
        return f;
      } else {
        return null;
      }
    });

    setFilterRows([...result]);
  }, [rows, props.search, props.status]);

  const divRef = useRef<any>(null);

  const [height, setHeight] = useState<number>(0);

  useEffect(() => {
    if (divRef.current) {
      setHeight(divRef.current.offsetHeight);
    }
  }, [height]);

  return (
    <Box width={"100%"} height={"100%"} ref={divRef}>
      <>
        <TableContainer
          component={Paper}
          sx={{
            background: "var(--unstable_DataGrid-overlayBackground)",
            maxHeight: height - 52,
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell />
                <StyledTableCell>{t("ID")}</StyledTableCell>
                <StyledTableCell>{t("File-Name")}</StyledTableCell>
                <StyledTableCell>{t("Status")}</StyledTableCell>
                <StyledTableCell>{t("Upload-Date")}</StyledTableCell>
                <StyledTableCell>{t("Upload-By")}</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 && (
                <TableRow>
                  <TableCell
                    width={"40px"}
                    colSpan={7}
                    height={"220px"}
                    align="center"
                  >
                    <Typography variant="text1">{t("noRowsLabel")}</Typography>
                  </TableCell>
                </TableRow>
              )}

              {(rowsPerPage > 0
                ? filterRows.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
                  )
                : rows
              ).map((row) => {
                return <ImportDetailsTable key={row._id} row={row} />;
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 20]}
          component="div"
          count={filterRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={t("rows-per-page")}
        />
      </>
    </Box>
  );
};
